<template>
  <template v-if="pageList == 'activationlog'">
    <!-- 稼動率日誌 -->
    <activationLog></activationLog>
  </template>
  <template v-else-if="pageList == 'activationstatistics'">
    <!-- 稼動率統計 -->
    <activationStatistics></activationStatistics>
  </template>
</template>

<script>
import { useStore } from "vuex";
import { computed, onUnmounted, provide, ref, watch } from "@vue/runtime-core";
import activationLog from "@/components/activation/activationLog";
import activationStatistics from "@/components/activation/activationStatistics";
export default {
  components: {
    activationLog,
    activationStatistics,
  },
  setup() {
    const store = useStore();

    //getters
    const sideBarSelect = computed(
      () => store.getters["sideBarTree/get_sideBarSelect"]
    );

    const pageList = ref();
    const pageListChild = ref();

    //function
    const setSessionItems = () => {
      sessionStorage.setItem(
        "mes-activation-pageList",
        pageList.value
      );
      sessionStorage.setItem(
        "mes-activation-pageListChild",
        pageListChild.value
      );
    };
    window.addEventListener("beforeunload", setSessionItems);

    watch(sideBarSelect, (newValue) => {
      pageList.value = newValue.pageList;
      pageListChild.value = newValue.pageListChild;
    });

    setTimeout(() => {
      pageList.value = sideBarSelect.value.pageList;
      pageListChild.value = sideBarSelect.value.pageListChild;

      //session資料
      const mesActivationPageList = sessionStorage.getItem(
        "mes-activation-pageList"
      );
      const mesActivationPageListChild = sessionStorage.getItem(
        "mes-activation-pageListChild"
      );
      sessionStorage.removeItem("mes-activation-pageList");
      sessionStorage.removeItem("mes-activation-pageListChild");
      if (mesActivationPageList != null) {
        pageList.value = mesActivationPageList;
      }
      if (mesActivationPageListChild != null) {
        pageListChild.value = mesActivationPageListChild;
      }
    }, 0);

    provide("pageList", pageList);
    provide("pageListChild", pageListChild);

    onUnmounted(() => {
      window.removeEventListener("beforeunload", setSessionItems);
    });

    return { pageList };
  },
};
</script>

<style></style>
<style lang="scss"></style>
